<template>
  <div class="ftb">
    <div class="inner">
      <ul class="meau">
        <li style="display: inline;">友情链接</li>
        <li style="display: inline;">|</li>
        <li style="display: inline;">
          <a target="_blank" href="http://www.h2o-china.com/link/">中国水网</a>
        </li>
        <li style="display: inline;">|</li>
        <li style="display: inline;">
          <a target="_blank" href="http://www.supplywater.com/">长沙自来水</a>
        </li>
        <li style="display: inline;">|</li>
        <li style="display: inline;">
          <a target="_blank" href="http://www.waternet.com.cn/">株洲自来水</a>
        </li>
        <li style="display: inline;">|</li>
        <li style="display: inline;">
          <a target="_blank" href="http://www.xtjxwater.com/">湘潭自来水</a>
        </li>
        <li style="display: inline;">|</li>
        <li style="display: inline;">
          <a target="_blank" href="http://www.hhzls.com/">怀化自来水</a>
        </li>
      </ul>
      <p>公司名称：吉首市城市供水总公司 电话：0743-8223284 传真：0743-8223284 邮编：416000</p>
      <p>Copy Right © Jszls.com.cn All Right Resseved 备案号：<a target="_blank" href="https://beian.miit.gov.cn/">湘ICP备2022017547号-1</a></p>
    </div>
  </div>
</template>

<script>
export default {
    name:'footer-box'
};
</script>

<style scoped>
.ftb{background:#000; padding:20px 0; text-align:center; line-height:2; font-size:13px;position: fixed;bottom: 0;width: 100%;z-index: 999;}
.ftb p{ color:#a2a2a2;}
.ftb p a{color:#a2a2a2; background:none;}
.ftb p a:hover{ color:#c10707;-webkit-transition: all .5s;transition: all .5s;}
.meau li{ display:inline-block; list-style:none; line-height:2; margin-bottom:20px;color:#a2a2a2;}
.meau li a{ color:#fff;text-decoration: none}
.meau{ color:#a2a2a2;}
.meau li a:hover{ color:#c10707;-webkit-transition: all .5s;transition: all .5s;}
</style>


// WEBPACK FOOTER //
// src/components/front/footer/Footer.vue